import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";

function MidSec({ data, getTo }) {
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1],
        staggerChildren: 0.1
      }
    }
  };
  return (
    <div className="w-full border-gray-400">
      <a href={`/${getTo}/${data.title}`} >
        <motion.div
          className="w-full bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
          variants={cardVariants}
        >
          <div
            className="h-[220px] w-full relative overflow-hidden"
          >
            <img 
              src={data.coverimage} 
              alt={data.title} 
              className="w-full h-full object-cover object-top transition duration-300 group-hover:scale-105" 
            />
          </div>

          <div className="px-5 py-3 space-y-2">
            <motion.p
              className="text-lg font-semibold text-gray-800 hover:text-gray-600 transition-colors duration-300"
              whileHover={{ scale: 1.02 }}
            >
              {data.title}
            </motion.p>
            <div className="h-[1px] w-full bg-gray-100" />
            <p className="text-sm text-gray-600 line-clamp-2">
              {data.description}
            </p>
            <div className="flex items-center justify-between text-[10px] pt-2 text-gray-500">
              {data.date &&
                <div className="flex items-center gap-1">
                  <Calendar className="w-3 h-3" />
                  <span>{data.date}</span>
                </div>
              }
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-2 px-2 py-1 rounded-full text-[10px] hover:bg-gray-50 transition-colors duration-300"
              >
                Read more
                <ArrowRight className="w-3 h-3" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </a>
    </div>
  );
}

export default MidSec;
